<template>
  <div class="animated fadeIn">
    <staff-card v-if="staff" :staff="staff" />
    <b-form @submit.prevent="onSubmit">
      <b-row class="mt-4">
        <b-col>
          <b-card no-body>
            <b-card-header>
              <span class="text-muted text-uppercase">Staff Identification</span>
            </b-card-header>
            <div class="py-3 px-5">
              <b-form-group label="First Name" :label-cols="2">
                <b-form-input
                  v-model="form_data.first_name"
                  :state="!$v.form_data.first_name.$invalid"
                  invalid-feedback="Required"
                  placeholder="First Name"
                  type="text"
                />
              </b-form-group>
              <b-form-group label="Last Name" :label-cols="2">
                <b-form-input
                  v-model="form_data.last_name"
                  :state="!$v.form_data.last_name.$invalid"
                  invalid-feedback="Required"
                  placeholder="Last Name"
                  type="text"
                />
              </b-form-group>
              <b-form-group label="Title" :label-cols="2">
                <b-form-input
                  v-model="form_data.title"
                  :state="!$v.form_data.title.$invalid"
                  invalid-feedback="Required"
                  placeholder="Title"
                  type="text"
                />
              </b-form-group>
              <b-form-group label="Phone" :label-cols="2">
                <b-form-input
                  v-model="form_data.phone_number"
                  :state="!$v.form_data.phone_number.$invalid"
                  invalid-feedback="Required"
                  placeholder="(403)___-____"
                  type="number"
                />
              </b-form-group>
              <b-form-group label="Email" :label-cols="2">
                <b-form-input
                  v-model="form_data.email"
                  :state="!$v.form_data.email.$invalid"
                  invalid-feedback="Required"
                  placeholder="____@______.ca"
                  type="email"
                />
              </b-form-group>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <custom-checkbox-select-group
        :checked="form_data.laboratories"
        :collection_type="'laboratory'"
        :field="'laboratories'"
        :card_header="'Laboratory Selection'"
        @update="updateFormData"
      />
      <custom-checkbox-select-group
        :checked="form_data.work_groups"
        :collection_type="'workGroup'"
        :field="'work_groups'"
        :card_header="'Work Group & Role Selection'"
        @update="updateFormData"
      />
      <b-row>
        <b-col>
          <b-button @click="submitForm" class="mb-4 float-right py-3 px-5" variant="success">
            <i class="fal fa-address-book" /> Save
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import CustomCheckboxSelectGroup from "@/components/shared/form/CustomCheckboxSelectGroup";
import StaffCard from "@/components/lab/staff/StaffCard";
import { validationMixin } from "vuelidate/src";
import { required, email, helpers } from "vuelidate/lib/validators";

const phone = helpers.regex(
  "phone",
  /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\\./0-9]*$/
);

export default {
  name: "StaffForm",
  components: {
    CustomCheckboxSelectGroup,
    StaffCard
  },
  mixins: [validationMixin],
  props: {
    staff: {
      type: Object,
      default: () => null
    },
  },
  data() {
    return {
      form_data: {
        first_name: null,
        last_name: null,
        title: null,
        phone_number: null,
        email: null,
        work_groups: [],
        laboratories: []
      },
    }
  },
  validations: {
    form_data: {
      first_name: { required },
      last_name: { required },
      email: { required, email },
      phone_number: { required, phone },
      title: { required }
    }
  },
  methods: {
    updateFormData({ field, value }) {
      this.form_data[field] = value;
    },
    initFormData() {
      const { email, laboratories, phone_number, title, work_groups } = this.staff;

      this.form_data = {
        ...this.staff.cloneAttributes(true, true, ["id", "user_id"]),
        email,
        phone_number,
        title,
        work_groups: work_groups.map(({ id }) => id),
        laboratories: laboratories.map(({ id }) => id)
      };
      
    },
    submitForm() {
      this.$emit('submit', this.form_data);
    },
  },
  created() {
    this.staff && this.initFormData();
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
